
export default {
  name: 'FilterCategorySearch',
  // eslint-disable-next-line vue/require-prop-types
  props: ['dataFilter', 'buttonLoadMore', 'limit', 'textValue', 'textName', 'keyFilter', 'data'],
  data() {
    return {
      listData: [],
      listValue: [],
      showListFilter: true,
      loadMore: false
    }
  },
  methods: {
    resetValidate(ref) {
      this.$refs.accountForm.fields.find((f) => f.prop === ref).clearValidate()
      this.accountForm.errors[ref] = ''
    },
    checkShow(index) {
      if (this.buttonLoadMore !== true) return true
      if ((this.loadMore === false) && (index >= this.limit)) return false
      return true
    }
  }
}
